import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, Clock, MessageSquare } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { RedButton, GhostButton } from "@/components/Layout";
import { PageHero } from "@/components/PageHero";

export default function Contact() {
  const { settings, hoursText } = useSite();
  const s = settings || {};
  const tel = String(s.phone || "").replace(/\s/g, "");

  return (
    <div data-testid="contact-page">
      <PageHero overline="Nous joindre" title="Contact" />
      <section className="mx-auto max-w-3xl px-4 md:px-8 py-14">
        <div className="border border-sared bg-black p-7 md:p-10">
          <ul className="space-y-7">
            <li className="flex gap-4" data-testid="contact-phone">
              <Phone className="text-sared shrink-0" size={20} />
              <div>
                <div className="font-mono-tech text-[10px] tracking-[0.2em] text-zinc-500">TÉLÉPHONE</div>
                <a href={`tel:${tel}`} className="text-white mt-1 block hover:text-sared">{s.phone}</a>
              </div>
            </li>
            <li className="flex gap-4" data-testid="contact-email">
              <Mail className="text-sared shrink-0" size={20} />
              <div>
                <div className="font-mono-tech text-[10px] tracking-[0.2em] text-zinc-500">E-MAIL</div>
                <a href={`mailto:${s.email || ""}`} className="text-white mt-1 block hover:text-sared">{s.email}</a>
              </div>
            </li>
            <li className="flex gap-4" data-testid="contact-hours">
              <Clock className="text-sared shrink-0" size={20} />
              <div>
                <div className="font-mono-tech text-[10px] tracking-[0.2em] text-zinc-500">HORAIRES</div>
                <div className="text-white mt-1 whitespace-pre-line">{hoursText || s.hours}</div>
              </div>
            </li>
          </ul>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href={`sms:${tel}`} data-testid="sms-btn">
              <RedButton><MessageSquare size={14} className="inline mr-2" />SMS</RedButton>
            </a>
            <a href={`tel:${tel}`} data-testid="call-btn"><GhostButton>Appeler</GhostButton></a>
            <Link to="/rendez-vous" data-testid="contact-rdv-btn"><GhostButton>Prendre rendez-vous</GhostButton></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
